<script lang="ts">
	import { Tag } from '../../../../../components/Tag';
	import { filterStores } from '../../../state';

	import type { FilterDrawerState, FilterTag, FilterTagList } from '../../../types';
	import { getFilterCollectionValue } from '../../../utils/getFilterCollectionValue/getFilterCollectionValue';
	import { setFilterCollectionValue } from '../../../utils/setFilterCollectionValue/setFilterCollectionValue';

	interface Props {
		filterCollectionId: string;
		filterTagList: FilterTagList;
	}

	let { filterCollectionId, filterTagList }: Props = $props();

	let tags = $derived(filterTagList?.filter_tags);

	const { filterStore } = filterStores;

	const handleClick = (tag: FilterTag | null) => () => {
		if (tag?.value === undefined || tag?.value === null) return;

		const currentValue = getFilterCollectionValue({
			filterCollectionId,
			filter: $filterStore as FilterDrawerState
		}) as string[];

		if (currentValue.find((value) => value === tag?.value)) {
			const newValue = currentValue.filter((value) => value !== tag?.value);

			setFilterCollectionValue({
				filterCollectionId,
				value: newValue
			});

			return;
		}

		const newValue = [...currentValue, tag?.value];

		setFilterCollectionValue({
			filterCollectionId,
			value: newValue
		});
	};

	const isSelected = ({ tag, filter }: { tag: FilterTag | null; filter: FilterDrawerState }) => {
		if (tag?.value === undefined || tag?.value === null) return false;

		const currentValue = getFilterCollectionValue({
			filterCollectionId,
			filter
		}) as string[];

		if (currentValue === undefined) {
			return false;
		}

		return !!currentValue.find((value) => value === tag?.value);
	};
</script>

<!-- TODO filter drawer : adjust data-cy -->
{#if tags}
	<div class="flex flex-wrap gap-2">
		{#each tags as tag}
			<Tag
				dataCy={`filter-drawer-tag-id-${filterCollectionId}`}
				onClick={handleClick(tag)}
				selected={isSelected({ tag, filter: $filterStore as FilterDrawerState })}
			>
				<span class="flex items-center gap-1.5">
					{#if tag?.hexcode}
						<span
							style={`background-color: ${tag?.hexcode};`}
							class="block h-[1rem] w-[1rem] rounded-full border-2 border-gray-200 bg-red-300"
						></span>
					{/if}

					{tag?.label}
				</span>
			</Tag>
		{/each}
	</div>
{/if}
